module.exports = __webpack_public_path__ + "img/list-right.fa11345c.png";